import React from 'react';
import styles from './styles.module.scss';

type PropsDef = {
  selection: any[];
  onRemove: (id: number) => void;
  pillStyle?: boolean;
};

export default function SelectionList({ selection, onRemove, pillStyle }: PropsDef) {

  const userList = selection.map((user: any) => {
    return (
      <div key={user.id} className={pillStyle ? styles.list_item_pill : styles.list_item}>
        <div className={pillStyle ? styles.user_avatar_pill : styles.user_avatar}>
          <img className={pillStyle ? styles.user_avatar_pill : styles.user_avatar} src={user.profilePicture} />
          {!pillStyle && (
            <div className={styles.remove_item} onClick={() => onRemove(user.id)}>
              <i className="ico ico-x" />
            </div>
          )}
        </div>
        <div className={styles.chip_name}>
          {user.firstName} {user.lastName}
        </div>
        {pillStyle && (
          <div className={styles.remove_item_pill} onClick={() => onRemove(user.id)}>
            <i className="ico ico-x" />
          </div>
        )}
      </div>
    );
  });

  return (
    <div className={styles.list_container}>
      {userList}
    </div>
  );
}
